import { JobRequest } from "../../CRUDs/entities/JobRequest";
import { Customer } from "../../CRUDs/entities/Customer";
import { updateTables } from "../updateTables";
import { Visit } from "../../CRUDs/entities/Visit";
import { checkActionAttribute } from "./checkActionAttribute";
import { SectionSwitcher } from "../SectionSwitcher";

export const requestsModalActionsListners = (target, actionsWindow) => {

    const requestRow = target.parents('.data-row');
    const requestId = requestRow.data('id');
    const customerId = requestRow.data('customer-id');

    const customer = new Customer(customerId);
    const staticVisit = new Visit();

    const request = new JobRequest(requestId);

    // check sent quote or not
    if (requestRow.data('quote-sent')) actionsWindow.find('.create-quote').css('display', 'none');
    else actionsWindow.find('.create-quote').css('display', 'block');

    checkActionAttribute([
        { attribute: 'data-quote-not-sent',      className: 'create-quote' },

        { attribute: 'data-customer-active',     className: 'create-visit' },
        { attribute: 'data-customer-active',     className: 'request-action' },
        { attribute: 'data-customer-active',     className: 'edit-request' },
        { attribute: 'data-customer-active',     className: 'convert-to-job' },
        { attribute: 'data-customer-active',     className: 'view-request' },
        { attribute: 'data-customer-active',     className: 'create-quote' },
        { attribute: 'data-customer-active',     className: 'contact' },
        { attribute: 'data-customer-active',     className: 'attachments' },
        { attribute: 'data-quote-sent',     className: 'view-quotes' },
    ], target, actionsWindow);

    actionsWindow.find('.action').off();

    // view sent quote, details: not implemented!
    actionsWindow.find('.action.select').on('click', function () {
        const entityClass = $(this).attr('class').split(' ').pop().split('-').pop();
        const result = request.relatedEntities(entityClass);

        const sectionSwitcher = new SectionSwitcher();
        sectionSwitcher.showSelectedSection(entityClass);

        $(`.data-view.${entityClass}`).find('.data-row').addClass('d-none');
        for (let entityId of result) {
            $(`.data-view.${entityClass}`).find(`.data-row[data-id=${entityId}]`).removeClass('d-none');
        }
    });

    // contact customer
    actionsWindow.find('.action.contact').on('click', (e) => {
        customer.openModal('contact');
    });

    // send a quote
    actionsWindow.find('.action.create-quote').on('click', (e) => {
        window.open(`/jobs-flow/quote/create?job_request_id=${request.id}`, '_blank');
    });

    // mark request as job
    actionsWindow.find('.action.convert-to-job').on('click', (e) => {
        request.convertToJob();
    });

    // schedule a visit
    actionsWindow.find('.action.create-visit').on('click', (e) => {
        staticVisit.openModal('create', { job_request_id: request.id });
    });

    // view details
    actionsWindow.find('.action.view-request').on('click', (e) => {
        request.openModal('view');
    });

    // edit request
    actionsWindow.find('.action.edit-request').on('click', (e) => {
        request.openModal('edit');
    });

    // cancel request
    actionsWindow.find('.action.cancel-request').on('click', (e) => {
        request.changeStatus('cancel');
    });

    // view logs
    actionsWindow.find('.action.view-logs').on('click', (e) => {
        request.openModal('logs');
    });

    // view attachments
    actionsWindow.find('.action.attachments').on('click', (e) => {
        request.viewAttachments();
    });
}
